import { Mesh, Object3D, Vector3 } from 'three'
import gsap from 'gsap'
import Constants from '../lib/Constants'

export default class Bottles
{
    constructor(_options)
    {
        this.resources = _options.resources
        this.camera = _options.camera
        this.materials = _options.materials

        this.container = new Object3D()
        this.container.name = 'bottles_container'

        this.mat = this.materials.items.bottleMat
        this.disposeBottleFlag = false

        this.bottleMalva = this._createMesh(this.resources.items.bottleMalva.scene.children[0])
        this.bottlePassito = this._createMesh(this.resources.items.bottlePassito.scene.children[0])
        this.bottleSpumante = this._createMesh(this.resources.items.bottleSpumante.scene.children[0])
        this.bottleRosso = this._createMesh(this.resources.items.bottleRosso.scene.children[0])
    }

    _createMesh(baseMesh)
    {
        const bottleScale = 0.0375
        const mesh = new Mesh(baseMesh.geometry, this.mat)
        mesh.renderOrder = 2
        mesh.name = baseMesh.name
        mesh.castShadow = true
        mesh.receiveShadow = true

        mesh.scale.setScalar(bottleScale)
        mesh.userData.height = (baseMesh.geometry.boundingBox.max.y - baseMesh.geometry.boundingBox.min.y) * bottleScale

        return mesh
    }

    _setBottleMesh(wine)
    {
        switch(wine)
        {
            case 'Gemma':
                this._mesh = this.bottleMalva
                this.mat.uniforms.uColor.value = this.resources.items.bottleMalvaColorGemma
                this.mat.uniforms.uOpacity.value = this.resources.items.bottleMalvaOpacity
                break
            case 'Gemma Gentile':
                this._mesh = this.bottleMalva
                this.mat.uniforms.uColor.value = this.resources.items.bottleMalvaColorGentile
                this.mat.uniforms.uOpacity.value = this.resources.items.bottleMalvaOpacity
                break
            case 'Fonio':
                this._mesh = this.bottleMalva
                this.mat.uniforms.uColor.value = this.resources.items.bottleMalvaColorFonio
                this.mat.uniforms.uOpacity.value = this.resources.items.bottleMalvaOpacity
                break
            case 'EOS':
                this._mesh = this.bottlePassito
                this.mat.uniforms.uColor.value = this.resources.items.bottlePassitoColorEos
                this.mat.uniforms.uOpacity.value = this.resources.items.bottlePassitoOpacity
                break
            case 'Spumante':
            case 'Spumante Sophia':
            case 'Sophia':
                this._mesh = this.bottleSpumante
                this.mat.uniforms.uColor.value = this.resources.items.bottleSpumanteColorArs
                this.mat.uniforms.uOpacity.value = this.resources.items.bottleSpumanteOpacity
                break
            case 'Sauvignon Emy':
            case 'Emy':
                this._mesh = this.bottleMalva
                this.mat.uniforms.uColor.value = this.resources.items.bottleMalvaColorEmy
                this.mat.uniforms.uOpacity.value = this.resources.items.bottleMalvaOpacity
                break
            case 'Due Mondi':
                this._mesh = this.bottleRosso
                this.mat.uniforms.uColor.value = this.resources.items.bottleRossoColorDuemondi
                this.mat.uniforms.uOpacity.value = this.resources.items.bottleRossoOpacity
                break
            default:
                this._mesh = this.bottleMalva
                this.mat.uniforms.uColor.value = this.resources.items.bottleMalvaColorGemma
                this.mat.uniforms.uOpacity.value = this.resources.items.bottleMalvaOpacity
                console.warn('Requested wine does not exist:', wine)
                break
        }

        this.container.clear()
        this.container.add(this._mesh)
    }

    showBottle(wine, pos)
    {
        this.disposeBottleFlag = false

        // Set mesh
        this._setBottleMesh(wine)

        // Set position from raycaster pointed position
        this.startPosition = new Vector3(pos.x, pos.y - this.getBottleHeight() - 0.002, pos.z)
        this._mesh.position.copy(this.startPosition)

        // Set bottle rotation to face the camera
        this._mesh.rotation.y = Math.atan2(this.camera.instance.position.x - this.startPosition.x, this.camera.instance.position.z - this.startPosition.z)

        // Animate bottle
        gsap.to(this._mesh.position, {
            duration: Constants.CAMERA.clickAnimDuration,
            ease: 'Power2.easeInOut',
            delay: Constants.CAMERA.clickAnimDuration * 0.25,
            y: pos.y - 0.005
        })
    }

    hideBottle()
    {
        if(!this._mesh || !this.startPosition) return

        this.disposeBottleFlag = true
        gsap.to(this._mesh.position, {
            duration: Constants.RAYCAST.textAnimDuration,
            y: this.startPosition.y - 0.05
        }).then(() => {
            if(this.disposeBottleFlag) this.container.clear()
        })
    }


    getBottleHeight()
    {
        return this._mesh.userData.height
    }
}